import { render, staticRenderFns } from "./designSearch.vue?vue&type=template&id=07720454"
import script from "./designSearch.vue?vue&type=script&lang=js"
export * from "./designSearch.vue?vue&type=script&lang=js"
import style0 from "./designSearch.vue?vue&type=style&index=0&id=07720454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports